import { getRequest, postRequest } from "api/tools/httpRequests";
import { debounce } from "lodash";
import React, { useEffect } from "react";
import { activityPriorityApi as api } from "../api/ActivityPriority.api";
import useParams from "activity/hooks/useParams";
import ActivityLoader from "activity/componenets/ActivityLoader";
import { IDMCActivity } from "commonFnBcode/types/dmc.types";
import ActivityAreaUpdate from "./ActivityAreaUpdate";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import CitiesList from "./CitiesList";

function ActivityPriorityCard() {
  const cityId = useParams("cityId");

  const { data, isFetching, refetch } = api.useGetActivitiesPriorityQuery(
    cityId ? parseInt(cityId) : 0
  );

  useEffect(() => {
    refetch();
  }, [cityId]);

  if (isFetching) return <ActivityLoader />;

  return (
    <div className="container my-4">
      <div className="row">
        <CitiesList filterBase="activities" />
        <div className="col-9">
          {data?.result?.map((activity: IDMCActivity) => (
            <div
              className="col-12 mb-4"
              key={Math.floor(Math.random() * 10000)}
            >
              <h5 className="text-dark m-0 pb-1">
                {activity.id} - {activity.name}
              </h5>
              <div
                className="d-flex justify-content-start py-3 px-4 rounded-2 align-items-center shadow-sm border border-dark gap-3"
                style={{ backgroundColor: "#f8f9fa" }}
              >
                <PriorityComp activity={activity} />
                <ToggleProperty
                  actField="isTurnedOn"
                  actId={activity.id}
                  label="isActive"
                  defaultValue={activity.isTurnedOn}
                />
                <ToggleProperty
                  actField="isTransferRequired"
                  actId={activity.id}
                  label="Compulsory Transfer"
                  defaultValue={activity.isTransferRequired}
                />
                <ActivityAreaUpdate activity={activity} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const PriorityComp = ({ activity }: { activity: IDMCActivity }) => {
  const [priority, setPriority] = React.useState(activity.priority || 1);
  const [updatePriority, isLoading] = api.useUpdatePriorityMutation();
  const handleSave = () =>
    updatePriority({ priority, activityId: activity.id });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPriority(Number(e.target.value));
  };
  return (
    <div className="d-flex align-items-center gap-2" style={{ width: "160px" }}>
      <strong className="text-danger">Priority:</strong>
      <input
        type="number"
        className="form-control form-control-sm w-25"
        value={priority}
        onChange={handleChange}
      />
      <button className="btn btn-success btn-sm btn-flat" onClick={handleSave}>
        Save
      </button>
    </div>
  );
};

const ToggleProperty = (props: {
  actId: number;
  label: string;
  actField: string;
  defaultValue?: boolean;
}) => {
  const { actId, actField, defaultValue, label } = props;
  const [check, setCheck] = React.useState(defaultValue || false);
  const [isLoading, setIsLoading] = React.useState(false);

  const apiFunc = async (isChecked) => {
    const url = `areas/toggleActivityFields`;
    setIsLoading(true);
    const response = await postRequest(url, {
      activityId: actId,
      [actField]: isChecked,
    });
    setIsLoading(false);
    if (!response.data?.success) {
      return toast.error(
        response.errorMessage || `Could not update activity ${label} state`
      );
    }
  };

  return (
    <div
      className="d-flex align-items-center gap-2"
      style={{ width: "max-content" }}
    >
      <p className="text-danger fw-bold m-0 p-0">{label}:</p>
      {isLoading ? (
        <Spinner />
      ) : (
        <input
          type="checkbox"
          className="form-check-input"
          checked={check}
          onChange={(e) => {
            setCheck(e.target.checked);
            apiFunc(e.target.checked);
          }}
        />
      )}
    </div>
  );
};

export default ActivityPriorityCard;
